import React from 'react'
import '../../App.css'
import FrontPage from '../FrontPage.js';
import Footer from '../Footer';
function Home(){
    return(
        <>
        <FrontPage/>
        <Footer />
        </>
    )
}
export default Home;